var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup32(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    width: 149.243,
    height: 156.435,
    viewBox: "0 0 149.243 156.435",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    transform: "translate(-1887.531 -1561.24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M3040.164,713.17V678.561a4.509,4.509,0,0,0-4.509-4.509H3000.9a4.509,4.509,0,0,0-4.509,4.509V713.17a4.509,4.509,0,0,0,4.509,4.509h34.756a4.509,4.509,0,0,0,4.509-4.509",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M3056.442,583.823a4.444,4.444,0,0,1-1.317-3.157V568.444h8.961v12.222a4.472,4.472,0,0,1-4.474,4.474,4.423,4.423,0,0,1-3.17-1.317",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M3015.1,583.823a4.431,4.431,0,0,1-1.3-3.157V568.444h8.96v12.222a4.484,4.484,0,0,1-4.487,4.474,4.424,4.424,0,0,1-3.17-1.317",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M2973.782,583.823a4.391,4.391,0,0,1-1.317-3.157V568.444h8.961v12.222a4.484,4.484,0,0,1-4.487,4.474,4.391,4.391,0,0,1-3.157-1.317",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M3092.9,592.393v13.24a4.515,4.515,0,0,1-4.513,4.513H2948.163a4.5,4.5,0,0,1-4.5-4.513v-13.24a23.949,23.949,0,0,1,23.949-23.949h.091v12.222a9.242,9.242,0,0,0,18.483,0V568.444h22.854v12.222a9.235,9.235,0,1,0,18.47,0V568.444h22.866v12.222a9.235,9.235,0,1,0,18.471,0V568.444h.1a23.949,23.949,0,0,1,23.949,23.949",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M2996.39,623.614v36.969a4.51,4.51,0,0,0,4.509,4.51h34.756a4.51,4.51,0,0,0,4.509-4.51V623.614a4.509,4.509,0,0,0-4.509-4.509H3000.9a4.509,4.509,0,0,0-4.509,4.509",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M3088.388,619.1h-34.756a4.509,4.509,0,0,0-4.509,4.509v36.97a4.509,4.509,0,0,0,4.509,4.509h34.756a4.509,4.509,0,0,0,4.509-4.509v-36.97a4.509,4.509,0,0,0-4.509-4.509",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M3049.124,678.561V713.17a4.509,4.509,0,0,0,4.509,4.509h15.314a23.95,23.95,0,0,0,23.95-23.951V678.561a4.509,4.509,0,0,0-4.509-4.509h-34.755a4.509,4.509,0,0,0-4.509,4.509",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M2948.166,665.092h34.755a4.509,4.509,0,0,0,4.509-4.509v-36.97a4.509,4.509,0,0,0-4.509-4.509h-34.755a4.509,4.509,0,0,0-4.509,4.509v36.97a4.509,4.509,0,0,0,4.509,4.509",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M2982.921,674.052h-34.755a4.509,4.509,0,0,0-4.509,4.509v15.168a23.95,23.95,0,0,0,23.95,23.95h15.314a4.509,4.509,0,0,0,4.509-4.509V678.561a4.509,4.509,0,0,0-4.509-4.509",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M2981.426,565.731v14.935a4.484,4.484,0,0,1-4.487,4.474,4.5,4.5,0,0,1-4.474-4.474V565.731a4.484,4.484,0,0,1,4.474-4.487,4.422,4.422,0,0,1,3.17,1.317,4.48,4.48,0,0,1,1.317,3.17",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M2981.426,565.731v14.935a4.484,4.484,0,0,1-4.487,4.474,4.5,4.5,0,0,1-4.474-4.474V565.731a4.484,4.484,0,0,1,4.474-4.487,4.422,4.422,0,0,1,3.17,1.317,4.48,4.48,0,0,1,1.317,3.17",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M3022.762,565.731v14.935a4.484,4.484,0,0,1-4.487,4.474,4.473,4.473,0,0,1-4.473-4.474V565.731a4.474,4.474,0,0,1,4.473-4.487,4.5,4.5,0,0,1,4.487,4.487",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M3022.762,565.731v14.935a4.484,4.484,0,0,1-4.487,4.474,4.473,4.473,0,0,1-4.473-4.474V565.731a4.474,4.474,0,0,1,4.473-4.487,4.5,4.5,0,0,1,4.487,4.487",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M3064.086,565.731v14.935a4.472,4.472,0,0,1-4.474,4.474,4.5,4.5,0,0,1-4.487-4.474V565.731a4.487,4.487,0,0,1,4.487-4.487,4.423,4.423,0,0,1,3.17,1.317,4.469,4.469,0,0,1,1.3,3.17",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M3064.086,565.731v14.935a4.472,4.472,0,0,1-4.474,4.474,4.5,4.5,0,0,1-4.487-4.474V565.731a4.487,4.487,0,0,1,4.487-4.487,4.423,4.423,0,0,1,3.17,1.317,4.469,4.469,0,0,1,1.3,3.17",
    transform: "translate(-1056.125 999.996)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup32);
export default __webpack_public_path__ + "static/media/Group 32.554206a034756162012918e6e90d94e8.svg";
export { ForwardRef as ReactComponent };